<template>
    <div class="game-instance-list init">
        <div class="cps-page-top">
            <div class="jc-page-header">
                <el-page-header :title="$t('game.title')" />
                <div class="jc-box-action">
                    <span class="game-tutorial" @click=showGameInfo> {{ $t('game.list.tutorial')
                    }}</span>
                    <a :href="Config.GAME_HELP_URL" target="_blank">
                        {{ $t('game.helpDoc') }}
                    </a>
                </div>
            </div>
            <div class="jc-page-content">
                <section class="game-info" v-show="gameInfoVisible">
                    <el-tabs v-model="activeName">
                        <el-tab-pane :label="$t('game.list.windows')" name="windowsConnect" class="game-info-item">
                            <section class="methods">
                                <h3 class="methods-title">{{ $t('game.list.windowsConnect') }}<span
                                        class="methods-title-connect">{{
                                            $t('game.list.connnectSetting') }}</span>
                                    <span class="game-guide-button" @click="goToSteam">{{ $t('game.list.gameGuide')
                                    }}</span>
                                </h3>
                                <section class="methods-content">
                                    <div class="methods-content-first mr35">
                                        <h3 class="title">{{ $t('game.list.windowsConnectContent.method1') | withColon }}
                                        </h3>
                                        <p class="content">
                                            需要在游戏服务器列表中，点击<span class="text">"一键下载文件"</span>，保存文件到Windows
                                            本地，双击保存的文件或者右键打开文件，即可连接游戏服务器。
                                        </p>
                                    </div>
                                    <div class="methods-content-second">
                                        <h3 class="title">
                                            <span>{{ $t('game.list.windowsConnectContent.method2') | withColon }}</span>
                                            <span class="field">{{
                                                $t('game.list.windowsConnectContent.method2Field') }}</span>
                                        </h3>
                                        <div class="content">
                                            <p class="content-item">
                                                <span class="content-item-icon icon1"></span>
                                                <span class="content-item-field">在Windows中找到并运行“远程桌面连接”(可以在工具栏搜索框中搜索或者在开始菜单
                                                    “Windows附件”中找到或者输入mstsc远程桌面连接命令按回车键)</span>
                                            </p>
                                            <p class="content-item">
                                                <span class="content-item-icon icon2"></span>
                                                <span class="content-item-field">在“计算机”输入框中输入游戏服务器的“公网IP”</span>
                                            </p>
                                            <p class="content-item">
                                                <span class="content-item-icon icon3"></span>
                                                <span class="content-item-field">在“用户名”输入框中输入“administrator”</span>
                                            </p>
                                            <p class="content-item">
                                                <span class="content-item-icon icon4"></span>
                                                <span class="content-item-field">点击连接，在弹出框中输入之前购买游戏服务器设置的“密码”</span>
                                            </p>
                                            <p class="content-item mt10">
                                                <span>如果连接成功，会弹出“证书”弹框，选择“同意”，即可看到Windows桌面</span>
                                            </p>
                                        </div>
                                    </div>
                                </section>
                            </section>
                            <section class="practices">
                                <h3 class="practices-title">{{ $t('game.list.practices') }}</h3>
                                <p class="practices-wukong">{{ $t('game.list.wukong') }}-<a
                                        :href="Config.GAME_DEPLOYMENT_URL" target="_blank">
                                        {{ $t('game.list.rapidDeployment') }}
                                    </a></p>
                                <h3 class="practices-title">{{ $t('game.list.recommendation') }}</h3>
                                <section class="image-container">
                                    <p class="image-icon wukong">
                                    </p>
                                    <div class="image-content">
                                        您需自行到<a :href="Config.STEAM_URL" target="_blank">Steam
                                        </a>购买黑神话悟空游戏，通过快速部署即可畅玩
                                    </div>
                                </section>
                            </section>
                            <section class="questions">
                                <h3 class="questions-title">{{ $t('game.list.questions') }}</h3>
                                <div class="questions-content">
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.modifyBw') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.modifyCon') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.connectServer') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.renewal') }}
                                        </a></p>
                                </div>
                            </section>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('game.list.mac')" name="macConnect" class="game-info-item">
                            <section class="methods">
                                <h3 class="methods-title">{{ $t('game.list.macConnect') }}<span
                                        class="methods-title-connect">{{
                                            $t('game.list.connnectSetting') }}</span>
                                    <span class="game-guide-button" @click="goToSteam">{{ $t('game.list.gameGuide')
                                    }}</span>
                                </h3>
                                <h3 class="tips"><span class="icon-caution"></span><span>{{
                                    $t('game.list.macConnectContent.tips') }}</span>
                                </h3>
                                <section class="methods-content">
                                    <div class="methods-content-first mr35">
                                        <h3 class="title">{{ $t('game.list.windowsConnectContent.method1') | withColon }}
                                        </h3>
                                        <p class="content">
                                            需要在游戏服务器列表中，点击<span class="text">"一键下载文件"</span>，保存文件到Mac本地，双击保存的文件，即可连接游戏服务器。
                                        </p>
                                    </div>
                                    <div class="methods-content-second">
                                        <h3 class="title">
                                            <span>{{ $t('game.list.windowsConnectContent.method2') | withColon }}</span>
                                            <span class="field">{{
                                                $t('game.list.windowsConnectContent.method2Field') }}</span>
                                        </h3>
                                        <div class="content">
                                            <p class="content-item">
                                                <span class="content-item-icon icon1"></span>
                                                <span class="content-item-field">运行Mac电脑预先安装的Windows远程桌面软件(比如 Microsoft
                                                    Remote Desktop)，添加PC/连接</span>
                                            </p>
                                            <p class="content-item">
                                                <span class="content-item-icon icon2"></span>
                                                <span class="content-item-field">在“PC名称”输入框中输入游戏服务器的“公网IP”</span>
                                            </p>
                                            <p class="content-item">
                                                <span class="content-item-icon icon3"></span>
                                                <span class="content-item-field">在“用户账户”输入框中输入“administrator”</span>
                                            </p>
                                            <p class="content-item">
                                                <span class="content-item-icon icon4"></span>
                                                <span class="content-item-field">点击连接，在弹出框中输入之前购买游戏服务器设置的“密码”</span>
                                            </p>
                                            <p class="content-item mt10">
                                                <span>如果连接成功，会弹出“证书”弹框，选择“同意”，即可看到Windows桌面</span>
                                            </p>
                                        </div>
                                    </div>
                                </section>
                            </section>
                            <section class="practices">
                                <h3 class="practices-title">{{ $t('game.list.practices') }}</h3>
                                <p class="practices-wukong">{{ $t('game.list.wukong') }}-<a
                                        :href="Config.GAME_DEPLOYMENT_URL" target="_blank">
                                        {{ $t('game.list.rapidDeployment') }}
                                    </a></p>
                                <h3 class="practices-title">{{ $t('game.list.recommendation') }}</h3>
                                <section class="image-container">
                                    <p class="image-icon wukong">
                                    </p>
                                    <div class="image-content">
                                        您需自行到<a :href="Config.STEAM_URL" target="_blank">Steam
                                        </a>购买黑神话悟空游戏，通过快速部署即可畅玩
                                    </div>
                                </section>
                            </section>
                            <section class="questions">
                                <h3 class="questions-title">{{ $t('game.list.questions') }}</h3>
                                <div class="questions-content">
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.modifyBw') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.modifyCon') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.connectServer') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.renewal') }}
                                        </a></p>
                                </div>
                            </section>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('game.list.other')" name="otherConnect" class="game-info-item">
                            <section class="methods">
                                <h3 class="methods-title">{{ $t('game.list.otherConnect') }}<span
                                        class="methods-title-connect">{{
                                            $t('game.list.connnectSetting') }}</span>
                                    <span class="game-guide-button" @click="goToSteam">{{ $t('game.list.gameGuide')
                                    }}</span>
                                </h3>
                                <section class="methods-content">
                                    <h3 class="other-item"> 可以自行安装支持RDP协议的远程桌面软件，创建“新连接”，输入地址(公网IP)，输入用户名
                                        (administrator)，输入密码(购买时设置)，即可连接游戏服务器。
                                    </h3>
                                </section>
                            </section>
                            <section class="practices">
                                <h3 class="practices-title">{{ $t('game.list.practices') }}</h3>
                                <p class="practices-wukong">{{ $t('game.list.wukong') }}-<a
                                        :href="Config.GAME_DEPLOYMENT_URL" target="_blank">
                                        {{ $t('game.list.rapidDeployment') }}
                                    </a></p>
                                <h3 class="practices-title">{{ $t('game.list.recommendation') }}</h3>
                                <section class="image-container">
                                    <p class="image-icon wukong">
                                    </p>
                                    <div class="image-content">
                                        您需自行到<a :href="Config.STEAM_URL" target="_blank">Steam
                                        </a>购买黑神话悟空游戏，通过快速部署即可畅玩
                                    </div>
                                </section>
                            </section>
                            <section class="questions">
                                <h3 class="questions-title">{{ $t('game.list.questions') }}</h3>
                                <div class="questions-content">
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.modifyBw') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.modifyCon') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.connectServer') }}
                                        </a></p>
                                    <p class="questions-content-item"> <a :href="Config.GAME_FAQ_URL" target="_blank">
                                            {{ $t('game.list.question.renewal') }}
                                        </a></p>
                                </div>
                            </section>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('game.list.steamGuide')" name="steamGuide">
                            <section class="steam-guide first-guide">
                                <h3 class="methods-title">{{ $t('game.list.steamGuideTitle') }}
                                </h3>
                                <div class="steam-guide-tips mt10">
                                    <h3 class="title">{{ $t('game.list.steamGuideTips.setSteam') }}</h3>
                                    <div class="content mt10 pr20">
                                        <p class="content-item">
                                            <span class="content-item-icon icon1"></span>
                                            <span>通过“远程连接”（<span class="one-click-tip"
                                                    @click="goToWindows">Windows连接</span>/<span class="one-click-tip"
                                                    @click="goToMac">Mac连接</span>）进入PC游戏服务器，双击Accout脚本，取消勾选“要使用本计算机必须输入用户名密码”，点击应用输入游戏服务器密码，点击确认。</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon2"></span>
                                            <span>开启PC游戏服务器上的Steam客户端，登录自己的Steam账号（如果没有Steam账号请参考“<a
                                                    href="https://docs.jdcloud.com/cn/cloud-physical-server/steam"
                                                    target="_blank">如何注册Steam账号并购买游戏</a>”教程），选择顶部导航到“库”，并点击左侧的黑悟空游戏</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon3"></span>
                                            <span>切换到本地电脑，开启Steam客户端，登录自己的Steam账号，选择顶部导航到“库”，并点击左侧的黑悟空游戏，点击右侧“流式传输”按钮，稍等随后会弹出“授权码”</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon4"></span>
                                            <span>切换到PC游戏服务器上的Steam客户端，将刚刚本地电脑上弹出的“授权码”输入进行绑定，确认绑定成功（如果不成功，请重复③④步骤）</span>
                                        </p>
                                        <p class="content-item mt10">
                                            <span class="content-item-icon icon5"></span>
                                            <span>绑定成功后，直接在PC游戏服务器内选择“重启”，此时远程连接会断开。注意：重启PC游戏服务器之后，一定暂时不要再远程连接PC游戏服务器，否则会导致Steam串流游玩失败（如果需要调整其他设置，可远程连接进行设置，但设置完毕后记得再次“重启”PC游戏服务器）</span>
                                        </p>
                                    </div>
                                </div>
                            </section>
                            <section class="steam-guide second-guide">
                                <div class="steam-guide-tips">
                                    <h3 class="title">{{ $t('game.list.steamGuideTips.streamGames') }}</h3>
                                    <div class="desc mt10">
                                        在完成上述“设置Steam”操作后，请在本地电脑Steam客户端等待串流初始化，此过程大概等待3-5分钟，这个过程本地客户端“黑悟空游戏”的按钮会出现状态变化，具体变化过程如下：
                                    </div>
                                    <div class="content mt5">
                                        <p class="content-item">
                                            <span class="content-item-icon icon1"></span>
                                            <span>按钮显示“流式传输”，无须点击，请继续等待</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon2"></span>
                                            <span>按钮显示“安装”，不要点击，请继续等待（因为我们是串流模式游玩，因此不需要本地安装游戏，如果本地已经安装，此时会显示“开始游戏”）</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon3"></span>
                                            <span>按钮显示“流式传输”，双击按钮，此时会弹出提示窗让选择启动选项，直接点击下放的“开始游戏”，此时远端PC游戏服务器开始启动黑悟空游戏，大概3-5分钟，请继续等待</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon4"></span>
                                            <span>按钮显示“连接”，双击按钮，此时本地电脑会加载Steam串流客户端，并在本地电脑主屏进入串流游玩界面，请稍作等待</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon5"></span>
                                            <span>在本地电脑主屏的串流客户端游戏界面，等待黑悟空游戏加载完毕，即可畅玩。</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon6"></span>
                                            <span>若需要中途退出游戏，可通过快捷键“windows键+tab键”切换到本地Steam页面，点击”停止“按钮；如果在串流中退出游戏，下次进入游戏只需要重复③④⑤即可</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon7"></span>
                                            <span>若通过中途“停止”按钮关闭游戏，下次要重新连接，点击“连接”按钮即可</span>
                                        </p>
                                    </div>
                                </div>
                            </section>
                            <section class="steam-guide third-guide">
                                <div class="steam-guide-tips ">
                                    <h3 class="title">{{ $t('game.list.steamGuideTips.exceptionHandling') }}</h3>
                                    <div class="content mt10">
                                        <p class="content-item">
                                            <span class="content-item-icon icon1"></span>
                                            <span>任何时候，通过远程连接PC游戏服务器进行设置调整后，需要重启PC游戏服务器后才能进行串流</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon2"></span>
                                            <span>在进行“串流玩游戏”时，如果在③④步出现闪退，那么请重启PC游戏服务器</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon3"></span>
                                            <span>在进行“串流玩游戏”时，如果在③④步出现弹窗提示“流失传输启动失败”，那么请检查本地路由器的安全策略，建议全部关闭后再重试，如果多次失败后还是出现“流失传输启动失败”，请使用ToDesk模式畅玩。</span>
                                        </p>
                                    </div>
                                </div>
                            </section>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('game.list.deskGuide')" name="deskGuide">
                            <section class="steam-guide first-guide">
                                <h3 class="methods-title">{{ $t('game.list.deskGuideTitle') }}
                                </h3>
                                <div class="steam-guide-tips mt10">
                                    <h3 class="title">{{ $t('game.list.deskGuideTips.setSteam') }}</h3>
                                    <div class="content mt10 pr20">
                                        <p class="content-item">
                                            <span class="content-item-icon icon1"></span>
                                            <span>通过“远程连接”（<span class="one-click-tip"
                                                    @click="goToWindows">Windows连接</span>/<span class="one-click-tip"
                                                    @click="goToMac">Mac连接</span>）进入PC游戏服务器</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon2"></span>
                                            <span>开启PC游戏服务器上的ToDesk客户端，登录自己的ToDesk账号（如果没有ToDesk账号请参考“<a
                                                    href="https://docs.jdcloud.com/cn/cloud-physical-server/todesk"
                                                    target="_blank">如何注册ToDesk账号并升级成游戏版</a>”教程）</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon3"></span>
                                            <span>记录PC游戏服务器的“设备代码”和“临时密码”，如果不想使用临时密码，可以点击临时密码旁边的“按钮”，在弹出框内设置“安全密码”</span>
                                        </p>
                                    </div>
                                </div>
                            </section>
                            <section class="steam-guide second-guide">
                                <div class="steam-guide-tips">
                                    <h3 class="title">{{ $t('game.list.deskGuideTips.streamGames') }}</h3>
                                    <div class="desc mt10">在完成上述“ToDesk设置”操作后，切换到本地电脑</div>
                                    <div class="content mt5">
                                        <p class="content-item">
                                            <span class="content-item-icon icon1"></span>
                                            <span>开启本地电脑ToDesk客户端，登录自己的ToDesk账号</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon2"></span>
                                            <span>在“远程控制设备”输入框内输入PC游戏服务器上ToDesk客户端显示的“设备代码”，点击“连接”按钮</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon3"></span>
                                            <span>在弹出的输入框中输入PC游戏服务器上ToDesk客户端显示的“临时密码”（如果关闭临时密码，则输入自己设置的“安全密码”）</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon4"></span>
                                            <span>连接成功，ToDesk显示PC游戏服务器桌面，此时可以关闭“Windows或者Mac电脑的远程连接，后续都是用ToDesk操作即可”</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon5"></span>
                                            <span>使用ToDesk显示的PC游戏服务器桌面，像操作本地电脑一样操作PC游戏服务器，开启黑悟空游玩即可。</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon6"></span>
                                            <span>游玩完毕或者中途休息，可以退出ToDesk远程连接，后续继续游玩直接重复②③即可。</span>
                                        </p>
                                        <p class="content-item">
                                            <span class="content-item-icon icon7"></span>
                                            <span>若通过中途“停止”按钮关闭游戏，下次要重新连接，点击“连接”按钮即可</span>
                                        </p>
                                    </div>
                                </div>
                            </section>
                            <section class="steam-guide third-guide">
                                <div class="steam-guide-tips ">
                                    <h3 class="title">{{ $t('game.list.deskGuideTips.exceptionHandling') }}</h3>
                                    <div class="desc mt10">ToDesk游戏版专门针对游戏优化，建议参考图文教程进行设置，已获得更好的游戏体验。</div>

                                </div>
                            </section>
                        </el-tab-pane>
                    </el-tabs>
                    <!-- <section>
                        <span class="play-button">
                            <span class="icon-play"></span>
                            <span class="play-button-text">视频演示专区</span>
                        </span>
                    </section> -->
                    <i @click="hideGameInfo" class="el-icon-close close-button">
                    </i>
                </section>
                <div class="jc-container-table">
                    <div class="jc-container-table-actionBar flex-display">
                        <el-form class="jc-table-actionBar-item" :inline="true">
                            <el-form-item class="game-instance-refresh">
                                <el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="iconRefreshList">
                                </el-button>
                            </el-form-item>
                            <el-form-item style="margin-right: 0;">
                                <el-radio-group v-model="region" @change="regionChange">
                                    <el-radio-button v-for="area in regions" :key="area.region" :label="area.region">
                                        {{ area.regionName }}
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <!-- 返回边缘edcps游戏创建列表页 -->
                            <el-button @click="jumpToEDCPSGame" style="margin: 0px 20px 0 -4px ">{{ $t('game.action.backCPSGameListText') }}<i class="el-icon-top-right el-icon--right"></i></el-button>
                            <el-form-item>
                                <el-tooltip :content="$t('game.tips.createTip')" placement="top">
                                    <el-button type="primary" @click="jumpToCreate">
                                        {{ $t('game.list.create') }}
                                    </el-button>
                                </el-tooltip>
                                <img src="~@/assets/img/game/hot.png" class="hot-img" />
                            </el-form-item>
                        </el-form>
                        <div class="search-input-list">
                            <el-form :inline="true">
                                <!--自定义设置-->
                                <el-form-item>
                                    <el-button class="jc-button-icon operate-icon" icon="el-icon-setting"
                                        @click="customVisible = true" :title="$t('listPage.text.customList')">
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table ref="multipleTable" :data="realTableData" style="width: 100%" @filter-change="filterChange"
                        class="jc-table-header-cell jc-list-table" :empty-text="$t('speechCraft.listEmptyText')"
                        v-loading="loading">
                        <!--ID/实例名称-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.name')" key="id"
                            v-if="customInfo !== null && customInfo['id'].selected" width="280">
                            <template slot-scope="scope">
                                <p>{{ scope.row.instanceId }}</p>
                                <div>{{ scope.row.name }}</div>
                                <!--操作系统图片-->
                                <div class="os">
                                    <span :class="[scope.row.osType, 'game-os-icon']"></span>
                                    <span class="os-name">黑神话悟空 windows11</span>
                                </div>
                            </template>
                        </el-table-column>
                        <!--公网IP地址-->
                        <el-table-column key="ip" width="160" v-if="customInfo !== null && customInfo['ip'].selected"
                            :label="$t('listPage.tableLabel.publicIpAddr')">
                            <template slot-scope="scope">
                                <div>
                                    <div class="inline-ip" v-if="scope.row.publicIp">
                                        <div class="left">
                                            <p class="instance-ip">{{ scope.row.publicIp }}
                                            </p>
                                        </div>
                                        <div class="right">
                                            <copy-value :copyVal="`${scope.row.publicIp}`"></copy-value>
                                        </div>
                                    </div>
                                    <p v-else>{{ '--' }}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <!--状态-->
                        <el-table-column column-key="status" :label="$t('privateNetInstance.listTitle.status')" key="status"
                            :filter-multiple="true" :filters="filters.status" prop="status"
                            v-if="customInfo !== null && customInfo['status'].selected" width="100">
                            <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.status === 'error'"
                                    :content="$t('privateNetInstance.clickCommit')" placement="top">
                                    <span @click="createErrorOrder" :class="['my-error-status', 'jc-status-danger']"
                                        v-if="scope.row.status === 'error'">
                                        {{ transFormStatusName(scope.row.status) }}
                                    </span>
                                </el-tooltip>
                                <span v-else :class="getClassByStatue(scope.row.status)">
                                    <span class="icon-status icon-stopped icon-run"
                                        v-if="scope.row.status !== 'running' && scope.row.status !== 'stopped'">
                                    </span>
                                    {{ transFormStatusName(scope.row.status) }}
                                </span>
                            </template>
                        </el-table-column>
                        <!--规格类型-->
                        <el-table-column column-key="deviceType" prop="deviceType"
                            :label="$t('privateNetInstance.listTitle.spc')" key="specifications"
                            v-if="customInfo !== null && customInfo['specifications'].selected" width="160">
                            <template slot-scope="scope">
                                <span class="english-wrap">{{ scope.row.spec.name | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <!--配置-->
                        <el-table-column key="config" v-if="customInfo !== null && customInfo['config'].selected"
                            min-width="200" :label="$t('privateNetInstance.listTitle.config')">
                            <template slot-scope="scope">
                                <p> <span>{{ $t('game.create.gpu') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.gpu', [scope.row.spec.gpuDesc,
                                        scope.row.spec.gpuMemory]) }}</span>
                                </p>
                                <p> <span>{{ $t('game.create.cpu') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.cpu', [scope.row.spec.cpu,
                                        scope.row.spec.cpuCore]) }}</span>
                                </p>
                                <p> <span>{{ $t('game.create.memory') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.memory', [scope.row.spec.memoryDesc,
                                        scope.row.spec.memory]) }}</span>
                                </p>
                                <p> <span>{{ $t('game.create.sysDisk') | withColon(': ') }}</span>
                                    <span>{{
                                        $t('game.list.specificationType.sysDisk', [scope.row.spec.systemDisk,
                                        scope.row.spec.systemDiskType]) }}</span>
                                </p>
                                <p>
                                    <span>{{ $t('game.create.eip') | withColon(': ') }}</span>
                                    <span v-if="scope.row.spec.bw">
                                        {{ $t('game.list.specificationType.bw', [scope.row.spec.bw]) }}</span>
                                    <span v-else>--</span>
                                </p>
                            </template>
                        </el-table-column>
                        <!--计费信息-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.charge')" key="chargeInfo" min-width="200"
                            v-if="customInfo !== null && customInfo['chargeInfo'].selected">
                            <template slot-scope="scope">
                                <div v-if="scope.row.charge.chargeExpiredTime !== undefined">
                                    <p>
                                        {{ transformCharge(scope.row.charge.chargeMode) }}
                                        <span v-if="getCheckExpireInfo(scope.row) === 'will-retire'" class="expire-warning">
                                            {{ '(' + $t('listPage.text.hasExpired') + ')' }}
                                        </span>
                                    </p>
                                    <p class="list-expire-p">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                    </p>
                                    <p class="expire-warning list-expire-p bill-info-tip"
                                        v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.charge.chargeRetireTime">
                                        {{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
                                    </p>
                                    <p class="expire-warning list-expire-p bill-info-tip"
                                        v-if="getCheckExpireInfo(scope.row) === 'will-expire'">
                                        {{ scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired') }}
                                    </p>
                                    <p v-if="getCheckExpireInfo(scope.row) === 'available'"
                                        class="list-expire-p bill-info-tip">
                                        {{ scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired') }}
                                    </p>
                                </div>
                                <div v-else-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
                                    <p>
                                        {{ transformCharge(scope.row.charge.chargeMode) }}
                                        <span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
                                            class="expire-warning expire-warning">
                                            {{ '(' + $t('privateNetInstance.arrear') + ')' }}
                                        </span>
                                    </p>
                                    <p class="list-expire-p bill-info-tip"
                                        v-if="scope.row.charge.chargeStatus === 'normal'">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
                                    </p>
                                    <p class="list-expire-p expire-warning"
                                        v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
                                        {{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
                                    </p>
                                </div>
                                <div v-else>
                                    <span>--</span>
                                </div>
                            </template>
                        </el-table-column>
                        <!--链接方式-->
                        <el-table-column :label="$t('game.list.linkType')" key="linkType" min-width="100">
                            <template slot-scope="scope">
                                <el-tooltip placement="top" :content="$t('game.list.oneClickConnectionTip')">
                                    <span class="one-click-tip" @click="goToGuide">{{ $t('game.list.oneClickConnection')
                                    }}<a><i class="jc-icon-question"></i></a>
                                    </span>
                                </el-tooltip>
                                <el-button type="text" :disabled="canDownload(scope.row)" @click="downloadRdp(scope.row)">{{
                                    $t('game.list.oneClickDoc') }}</el-button>
                            </template>
                        </el-table-column>
                        <!--操作-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.operate')" key="operation"
                            v-if="customInfo !== null && customInfo['operation'].selected">
                            <template slot-scope="scope">
                                <operate-unit
                                    v-if="['stopped', 'stopping', 'error', 'reinstalling'].includes(scope.row.status)"
                                    :operateName="$t('privateNetInstance.open')" :disabled="OverdueConstantArray.includes(scope.row.charge.chargeStatus)
                                        || operateMap[statusListMap[scope.row.status]].indexOf('start') > -1
                                        || !scope.row.charge.chargeStatus
                                        " @handleClick="openIntance" :instanceInfo="scope.row"
                                    :operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo') : OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip') : $t('privateNetInstance.operations.onlyShutDown')">
                                </operate-unit>
                                <operate-unit v-else :operateName="$t('privateNetInstance.shutdown')" :disabled="OverdueConstantArray.includes(scope.row.charge.chargeStatus)
                                    || operateMap[statusListMap[scope.row.status]].indexOf('turnOff') > -1
                                    || !scope.row.charge.chargeStatus
                                    " @handleClick="closeInstance" :instanceInfo="scope.row"
                                    :operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo') : OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip') : $t('privateNetInstance.operations.onlyRunning')">
                                </operate-unit>
                                <p>
                                    <drop-down-operation :showType="'span'" :buttonTitle="$t('privateNetInstance.more')"
                                        :operations="scope.row.operations" :rowInfo="scope.row"
                                        @clickSelectItem="clickOperate">
                                    </drop-down-operation>
                                </p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <open :visible.sync="openIntanceVisible" :name="instanceInfo.name" :instanceId="instanceInfo.instanceId"
                    :region="this.region" @refresh="operateRefresh">
                </open>
                <close :visible.sync="closeInstanceVisible" :name="instanceInfo.name" :region="this.region"
                    :instanceId="instanceInfo.instanceId" @refresh="operateRefresh" :pageSource="'list'"
                    :rowInfo="instanceInfo">
                </close>
                <restart :visible.sync="restartInstanceVisible" :name="rowInfo.name" :region="this.region"
                    :instanceId="rowInfo.instanceId" @refresh="operateRefresh" :rowInfo="rowInfo" :pageSource="'list'">
                </restart>
                <reset-password :dialogVisible.sync="resetPasswordDialogVisible" v-if="resetPasswordDialogVisible"
                    :detail-data="rowInfo" @refreshData="iconRefreshList">
                </reset-password>
                <custom v-if="customVisible" :visible.sync="customVisible" :optionArr="optionArr" :type="type">
                </custom>
            </div>
        </div>
        <div v-if="listTotal > 0" class="cps-page-footer block jc-container-table-actionBar">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="listTotal">
            </el-pagination>
        </div>
        <!--删除实例-->
        <delete-instance :visible.sync="deleteVisible" @refresh="operateRefresh" :rowInfo="rowInfo" :pageSource="'list'">
        </delete-instance>
    </div>
</template>

<script>
import {
    getCustomInfoApi,
} from '@/api/common/actions';
import {
    getGameInstancesApi
} from '@/api/game/actions';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import operateUnit from '@/components/privateNetInstance/operateUnit/OperateUnit';
import custom from '@/components/common/custom/Custom';
import open from '@/components/game/Open';
import close from '@/components/game/Close';
import restart from '@/components/game/Restart';
import DeleteInstance from '@/components/game/DeleteInstance';
import ResetPassword from '@/components/game/ResetPassword';
import copyValue from '@/components/privateNetwork/CopyValue';
import {
    ServiceCodeConstant,
    OverdueConstantArray,
    ArrearConstantArray,
    ChargeModeConstant,
    GameRegionsConstant
} from "@/common/Constants";
import { deepCopy } from '@/common/tool';
import isDestroyingMixins from '@/mixins/isDestroying';
export default {
    name: 'GameInstanceList',
    mixins: [isDestroyingMixins],
    components: {
        open,
        close,
        dropDownOperation,
        operateUnit,
        custom,
        restart,
        ResetPassword,
        DeleteInstance,
        copyValue,
    },
    data() {
        return {
            activeName: "windowsConnect",
            gameInfoVisible: true,
            totalCount: 0, // 列表总数
            loading: false,
            statusMapName: {
                'creating': this.$t('privateNetInstance.statueNames.creating'),
                'starting': this.$t('privateNetInstance.statueNames.starting'),
                'running': this.$t('privateNetInstance.statueNames.running'),
                'stopping': this.$t('privateNetInstance.statueNames.stopping'),
                'stopped': this.$t('privateNetInstance.statueNames.stopped'),
                'restarting': this.$t('privateNetInstance.statueNames.restarting'),
                'error': this.$t('privateNetInstance.statueNames.error'),
                'upgrading': this.$t('privateNetInstance.statueNames.upgrading'),
                'reinstalling': this.$t('privateNetInstance.statueNames.reinstalling'),
                'destroying': this.$t('privateNetInstance.statueNames.destroying'),
                'inconfig': this.$t('privateNetInstance.statueNames.inconfig'),
                'resetting_password': this.$t('listPage.text.resettingPassword'),
                'making': this.$t('privateNetInstance.statueNames.making'),
            },
            azs: [],
            interStatus: ['creating', 'starting', 'stopping', 'restarting', 'upgrading',
                'reinstalling', 'destroying', 'inconfig', 'resetting_password', 'making'],
            instanceInfo: {},
            rowInfo: {},
            openIntanceVisible: false,
            closeInstanceVisible: false,
            restartInstanceVisible: false,
            resetPasswordDialogVisible: false,
            operateMap: {
                stopped: [
                    'restart'
                ],
                running: [
                    'resetPassword',
                    'delete'
                ],
                error: [
                    'start',
                    'turnOff',
                    'restart',
                    'bandWidth',
                    'renew',
                    'delete',
                ],
                creating: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'bandWidth',
                    'renew',
                    'delete',
                ],
                upgrading: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',

                    'bandWidth',
                    'renew',

                    'delete',
                ],
                destroying: [
                    'start',
                    'turnOff',
                    'restart',

                    'bandWidth',
                    'renew',

                    'delete',
                ],
                other: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',

                    'bandWidth',

                    'delete',
                ],
                noOperate: [
                    'starting',
                    'running',
                    'stopping',
                    'stopped',
                    'error',
                    'restarting',
                    'creating',
                    'destroying',
                    'upgrading',
                    'reinstalling',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                ]
            },
            statusListMap: {
                'starting': 'other',
                'running': 'running',
                'stopping': 'other',
                'stopped': 'stopped',
                'error': 'error',
                'restarting': 'other',
                'creating': 'creating',
                'destroying': 'destroying',
                'upgrading': 'upgrading',
                'reinstalling': 'other',
                'noOperate': 'noOperate',
                'other': 'other',
                'inconfig': 'other',
                'resetting_password': 'other',
            },
            operationsRenew: false,
            // 自定义列表弹框显示
            customVisible: false,
            type: 'gameInstanceList',
            statusMap: {
                // 关机
                'shutdown': 'jc-status-warning',
                // 运行
                'run': 'jc-status-success',
                // 中间态
                'intermediate': ' my-status my-status-middle ',
                // 错误
                'error': 'jc-status-danger',
            },
            status: '',
            region: '',
            regions: [],
            tableData: [],
            networkType: 'vpc',
            currentPage: 1,
            pageSizes: [20, 50, 100],
            pageSize: 20,
            optionArr: [
                {
                    // ID/名称
                    label: this.$t('privateNetInstance.listTitle.name'),
                    value: 'id'
                },
                {
                    // 公网IP地址
                    label: this.$t('listPage.tableLabel.publicIpAddr'),
                    value: 'ip'
                },
                {
                    // 状态
                    label: this.$t('privateNetInstance.listTitle.status'),
                    value: 'status'
                },
                {
                    // 规格
                    label: this.$t('privateNetInstance.listTitle.spc'),
                    value: 'specifications'
                },
                {
                    // 配置
                    label: this.$t('privateNetInstance.listTitle.config'),
                    value: 'config'
                },
                {
                    // 计费信息
                    label: this.$t('privateNetInstance.listTitle.charge'),
                    value: 'chargeInfo'
                },
                {
                    // 链接方式
                    label: this.$t('game.list.linkType'),
                    value: 'linkType'
                },
                {
                    // 操作
                    label: this.$t('privateNetInstance.listTitle.operate'),
                    value: 'operation'
                }
            ],
            statusTimeOut: null,
            deleteVisible: false,
            GameRegionsConstant: GameRegionsConstant,
            filters: {

                status: []
            },
            filterParams: {

                status: ''
            },
        };
    },
    computed: {
        ServiceCodeConstant: () => ServiceCodeConstant,
        customInfo() {
            return this.$store.state.customInfo[this.type];
        },
        realTableData() {
            if (typeof this.tableData === 'undefined') {
                return [];
            }
            if (this.tableData.length === 0) {
                return [];
            }
            return this.tableData.map((item) => {
                // 兼容status人工误修改的情况
                let operate = this.statusListMap[item.status] || 'other';
                const operations = [
                    {
                        operateName: this.$t('privateNetInstance.restart'),
                        disabled: this.operateMap[operate].indexOf('restart') > -1 || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyRunning'),
                        value: 'restart'
                    },
                    {
                        operateName: this.$t('privateNetInstance.operations.rePassword'),
                        disabled: this.operateMap[operate].indexOf('resetPassword') !== -1
                            || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyShutDown'),
                        value: 'resetPassword'
                    },
                    {
                        operateName: this.$t('eip.text.modifyBandwidth'),
                        disabled: true,
                        tip: this.$t('game.list.modifyBandwidth.tip'),
                        value: 'modifyBandwidth'
                    },
                    {
                        operateName: this.$t('privateNetInstance.operations.repay'),
                        disabled: this.operateMap[operate].indexOf('renew') > -1
                            || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : '',
                        value: 'repay'
                    },
                ];
                // 删除实例特殊处理
                const deleteOperate = {
                    operateName: this.$t('operations.delete.name'),
                    disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
                        || typeof item.charge.chargeStatus === 'undefined'
                        || this.operateMap[operate].indexOf('delete') > -1,
                    value: 'delete',
                    tip: ''
                };
                if (this.operateMap[operate].indexOf('delete') > -1) {
                    deleteOperate.tip = this.$t('operations.delete.tipWithStatus');
                }
                if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
                    deleteOperate.tip = this.$t('operations.delete.tip');
                }
                if (!item.charge.chargeStatus) {
                    deleteOperate.tip = this.$t('eip.help.noChargeInfo');
                }
                operations.push(deleteOperate);
                item.operations = operations;
                return item;
            });
        },
        /**
         * 返回查询到的列表总数
         * @return {number}
        */
        listTotal() {
            return this.totalCount;
        },
        OverdueConstantArray: () => OverdueConstantArray,
        ArrearConstantArray: () => ArrearConstantArray,
        ChargeModeConstant: () => ChargeModeConstant,
        canDownload: () => {
            return function (row) {
                if (row.publicIp) {
                    if (row.status !== 'running' && row.status !== 'stopped') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return true
                }
            }

        }
    },
    created() {
        if (this.$store.state.customInfo[this.type] === null) {
            this.getCustomInfo();
        }
        this.getRegions();

    },
    destroyed() {
        clearTimeout(this.statusTimeOut);
    },
    watch: {
        region(newValue) {
            if (newValue) {
                this.regionChange()
            }
        },
    },
    methods: {
        /**
         * @description 跳转边缘edcps云物理服务器游戏列表页
         * @description 读取edcps开通游戏服务器的白名单地域第一个值
        */
        jumpToEDCPSGame () {
          window.open('//cps-edge-console.jdcloud.com/instance/game/list', '_blank');
        },
        // 获得过滤
        getFilterLists(params) {
            Ajax.get('/api/filter/listInstances', params).then((res) => {
                if (res.errno === 10000 && res.data) {
                    Object.keys(res.data).forEach((key) => {
                        const filtersArray = [];
                        const filtersObj = res.data[key];
                        Object.keys(filtersObj).forEach((item) => {
                            const temp = {};
                            temp.value = item;
                            temp.text = filtersObj[item];
                            filtersArray.push(temp);
                        });
                        this.filters[key] = filtersArray;
                    });
                }
            }).finally(() => {
            });
        },

        filterChange(filter) {
            this.currentPage = 1;
            for (const key in filter) {
                switch (key) {
                    case 'status': {
                        this.status = filter[key].toString();;
                    }
                }
            }
            this.refreshWithLoading({});
        },

        goToWindows() {
            this.activeName = 'windowsConnect';
        },
        goToMac() {
            this.activeName = 'macConnect';
        },
        goToGuide() {
            this.$router.push({
                path: '/instance/game/guide'
            });
        },
        /**
         * 判断当前时间与到期、释放时间关系
         * @param row
         * @return {string}
        */
        getCheckExpireInfo(row) {
            if (row.charge.chargeExpiredTime !== undefined) {
                const now = Date.now();
                const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
                const DAYS = 1000 * 60 * 60 * 24;
                if (now > expire && row.charge.chargeRetireTime) {
                    return 'will-retire';
                }
                if (expire - now > 7 * DAYS) {
                    return 'available';
                }
                return 'will-expire';
            }
        },
        /*
         根据当前状态（返回字段statue）判断单个操作disabled
        */
        checkOperationDisable(data, status, chargeStatus) {
            let bool = this.operateMap[this.statusListMap[data.status]].indexOf(status) > -1;
            if (chargeStatus) bool = bool || OverdueConstantArray.includes(data.charge.chargeStatus);
            return bool;
        },
        // 切换可用区
        regionChange() {
            this.pageSize = 20;
            this.currentPage = 1;
            const params = {
                region: this.region,
                networkType: 'vpc'
            };
            this.refreshList(params);
            this.getFilterLists(params);
        },
        // 获得可用区
        getRegions() {
            const params = {
                networkType: 'vpc'
            };
            Ajax.get('api/cps/getRegions', params).then((res) => {
                if (res.data.regions.length) {
                    this.regions = res.data.regions.filter(item => this.GameRegionsConstant.includes(item.region)).map((item, index) => {
                        if (index === 0) {
                            if (this.$route.query && this.$route.query.region) {
                                this.region = this.$route.query.region;
                            } else {
                                this.region = item.region;
                            }
                        }
                        return {
                            region: item.region,
                            regionName: item.regionName
                        }
                    })
                }
            })
                .catch()
                .finally(() => {
                    this.loading = false
                });;
        },
        // 查询实例列表
        getInstanceList(params) {
            return getGameInstancesApi(params).then((res) => {
                if (res.data) {
                    this.tableData = res.data.instances.map(item => {
                        return {
                            ...item.instance,
                            chargeMode: item.instance.charge && item.instance.charge.chargeMode,
                            spec: item.spec || {}
                        }
                    });
                    this.totalCount = res.data.totalCount;
                }
            })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (e) {
                        console.log(e);
                    }
                })
                .finally(() => {
                    this.loading = false
                });
        },



        createErrorOrder() {
            Normal.goWorkPage();
        },
        // 续费
        renew(id) {
            const params = {
                resourceId: id,
                region: this.region,
                serviceCode: ServiceCodeConstant.CPS,
                resourceName: 'a'
            };
            Ajax.get('/api/order/submitRenew', params).then((res) => {
                const tempOrderId = res.data.tmpOrderId;
                window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cps`;
            });
        },
        clickOperate(value, rowInfo) {
            this.rowInfo = rowInfo;
            switch (value) {
                case 'restart':
                    this.restartInstanceVisible = true;
                    break;
                case 'resetPassword':
                    this.resetPasswordDialogVisible = true;
                    break;
                case 'repay':
                    this.renew(rowInfo.instanceId);
                    break;
                case 'delete':
                    this.deleteVisible = true;
                    break;
                default:
                    break;
            }
        },

        /**
         * @param size
         * 改变当前每页条数时触发
        */
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            const params = {
                pageSize: size,
            };
            this.refreshWithLoading(params);
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            const params = {
                pageNumber: page
            };
            this.refreshWithLoading(params);
        },
        // 刷新列表
        refreshList(params) {
            if (this.isDestroying) {
                return
            }
            const defaultParams = {
                region: this.region,
                networkType: 'vpc',
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
            };
            if (this.status) {
                defaultParams.status = this.status;
            }
            const realParams = Object.assign({}, defaultParams, params);
            this.getInstanceList(realParams).then(() => {
                const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
                if (refreshTag) {
                    clearTimeout(this.statusTimeOut);
                    this.statusTimeOut = setTimeout(() => {
                        this.refreshList(realParams);
                    }, 5000);
                }
            });
        },
        // 临时增加遮罩层
        refreshWithLoading(params) {
            if (this.isDestroying) {
                return
            }
            this.loading = true;
            const defaultParams = {
                region: this.region,
                networkType: 'vpc',
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
            };
            if (this.status) {
                defaultParams.status = this.status;
            }
            const realParams = Object.assign({}, defaultParams, params);
            this.getInstanceList(realParams).then(() => {
                this.loading = false;
                const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
                if (refreshTag) {
                    clearTimeout(this.statusTimeOut);
                    this.statusTimeOut = setTimeout(() => {
                        this.refreshList(realParams);
                    }, 5000);
                }
            }).finally(() => {
                this.loading = false
            })
        },

        iconRefreshList() {
            const params = {};
            this.refreshWithLoading(params);
        },

        // 自定义列
        getCustomInfo() {
            const params = {
                pageKey: this.type
            };
            getCustomInfoApi(params).then((res) => {
                if (res.data.customInfo) {
                    this.$store.commit(
                        'GET_CUSTOMINFO',
                        { value: res.data.customInfo, type: this.type }
                    );
                }
            }).catch(err => {
                console.log(err);
            })
        },
        closeInstance(operate, instance) {
            if (!operate) {
                this.instanceInfo = instance;
                this.closeInstanceVisible = true;
            }
        },
        openIntance(operate, instance) {
            if (!operate) {
                this.instanceInfo = instance;
                this.openIntanceVisible = true;
            }
        },
        operateRefresh() {
            this.refreshWithLoading({});
        },
        checkExpire(row) {
            if (row.charge.chargeExpiredTime !== undefined) {
                const nowDate = new Date();
                const expireDate = new Date(row.charge.chargeExpiredTime);
                const retireDate = new Date(row.charge.chargeRetireTime);
                const nowTime = nowDate.getTime();
                const expireTime = expireDate.getTime();
                const retireTime = retireDate.getTime();
                if (retireTime - nowTime < 7 * 24 * 3600 * 1000) {
                    return 'will-retire';
                }
                if (expireTime - nowTime < 7 * 24 * 3600 * 1000) {
                    return 'will-expire';
                }
                return 'available';
            }
        },
        transformCharge(payMethod) {
            switch (payMethod) {
                case 'prepaid_by_duration':
                    return this.$t('privateNetInstance.monthAndYear');
                case 'postpaid_by_duration':
                    return this.$t('create.text.byConfigurations');
                default:
                    return '';
            }
        },

        jumpToCreate() {
            this.$router.push({
                path: '/instance/game/create',
                query: { region: this.region }
            });
        },
        transformDeviceType(device) {
            switch (device) {
                case 'storage':
                    return this.$t('privateNetInstance.types.storage');
                case 'gpu':
                    return this.$t('privateNetInstance.types.GPU');
                case 'compute':
                    return this.$t('privateNetInstance.types.compute');
                default:
                    return '';
            }
        },

        getRegionName(region) {
            let regionName = '';
            this.regions.forEach((item) => {
                if (region === item.region) {
                    regionName = item.regionName;
                }
            });
            return regionName;
        },
        getClassByStatue(status) {
            switch (status) {
                case 'running':
                    return ['jc-status-success'];
                case 'error':
                    return ['jc-status-danger'];
                case 'stopped':
                    return ['jc-status-warning'];
                default:
                    return ['my-status', 'my-status-middle'];
            }
        },
        transFormStatusName(status) {
            return this.statusMapName[status];
        },
        /**
            * 当按配置购买的实例处于欠费状态时
            * 除删除操作外，其余操作置灰
            * @param item
            * @return {boolean}
        */
        instanceByConfigOpesDisabled(item) {
            return item.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION
                && OverdueConstantArray.includes(item.charge.chargeStatus);
        },

        showGameInfo() {
            this.gameInfoVisible = true;
        },

        hideGameInfo() {
            this.gameInfoVisible = false;
        },

        downloadRdp(row) {
            let canDownload = this.canDownload(row);
            if (canDownload) {
                return
            }
            const params = {
                region: this.region,
                instanceId: row.instanceId,
            };

            Ajax.download('GET', '/api/cps/instances/exportRdpFile', params, { baseURL: '/cps_api' })
                .then((res) => {
                    this.$message.success(this.$t('retailInstance.text.downloadSuccess'));
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                })
                .finally(() => {
                    this.handleClose();
                });;
        },

        goToSteam() {
            this.activeName = 'steamGuide'
        }

    },

};
</script>

<style lang="scss">
@import '../../../assets/scss/listComon';
@import '../../../assets/scss/paginationCommon';
@import '../../../assets/scss/sliderCommon';
@import '../../../assets/scss/statusCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/gameInstance/list/List.vue